import { Job } from '@models/Job'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { JOB_URL } from '@utils/urls'

const fetchJobs = (params: TableParams) =>
  SBAPI.FetchPaginated<Job[]>(JOB_URL, params)

const fetchJobById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Job>(`${JOB_URL}/${id}`, params)

const createJob = (job: Job) => SBAPI.Post(JOB_URL, job)

const updateJob = (job: Job) => SBAPI.Put(`${JOB_URL}/${job.id}`, job)

const deleteJob = (job: Job) => SBAPI.Delete(`${JOB_URL}/${job.id}`)

export { createJob, deleteJob, fetchJobById, fetchJobs, updateJob }
